import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useWindowSize from '../../../hooks/useWindowSize';

import { isEmpty, keys, pickBy } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';

import queryString from 'query-string';

import { array } from 'prop-types';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobModal from '../../../components/BobModal';
import CreateEquipmentOrSystemModal from '../EquipmentPage/CreateEquipmentOrSystemModal';
import DeleteSystemModal from '../SystemPage/DeleteSystemModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './Table.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const SystemsTable = ({
    activeTab,
    activeNavClient,
    activeNavCompany,
    bobLoading,
    companies,
    clientSystems,
    clientSystemsMeta,
    createEquipmentModalOpen,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    deleteSystemModalOpen,
    handleToggleDeleteSystemModal,
    fetchDashboardData,
    fetchNavClients,
    fetchSingleSite,
    isFromSystemTab,
    history,
    handleToggleCreateEquipmentModal,
    handleToggleSubscribeToSystemsAlertsModal,
    resetNavOptions,
    refreshTab,
    setRefreshTab,
    setNavCompany,
    setNavSite,
    setTableProps,
    searchTerm,
    subscribeToAlertsSystemsModalOpen,
    systemFilters,
    targetNavCompany,
    totalsData,
    workbookModeEnabled,
    ...props
}) => {
    const [sortFilter] = useState('');
    const [typeFilters, setTypeFilters] = useState([]);
    const [priorityFilters, setPriorityFilters] = useState([]);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [systemData, setSystemData] = useState(null);
    const [dataState, setDataState] = useState(initialDataState);
    const [systemColumnWidth, setSystemColumnWidth] = useState(250);

    const queryValues = queryString.parse(history.location.search);
    const companyId = queryValues.company;
    const clientId = queryValues.client;

    const isInitialMount = useRef(true);
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = columnList.map((c) => {
            c.width = c.field === 'systemName' ? 250 : c.width;
            if (c.field.toLowerCase().includes('faultcount')) {
                c.show = dashboardIsCurrentTimeStamp;
            }
            else {
                c.show = true;
            }
            return c;
        });
        const colWidth = calculateMinColumnWidths(columns.filter(c => c.show), gridDivRef.current.offsetWidth, 'systemName', 350, true);
        setSystemColumnWidth(colWidth);
        columns.find(c => c.id === 'systemColumn').width = colWidth;
        setColumnList(columns);
    }, [windowSize, dashboardIsCurrentTimeStamp]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
        setColumnList(columnList.map(c => {
            c.filterable = c.actionCell ? false : workbookModeEnabled;
            return c;
        }));    
    }, [workbookModeEnabled]);

    useEffect(() => {
        setSkip(0);
        setTake(10);
    }, [clientId]);

    useEffect(() => {
        if (systemFilters.type || Object.values(systemFilters.priority).includes(true)) {
            const typeFilters = systemFilters.type.map(filter => filter.id);
            const priorityFilters = keys(pickBy(systemFilters.priority));

            setTypeFilters(typeFilters);
            setPriorityFilters(priorityFilters);
        }
    }, []);

    useEffect(() => {
        if (activeNavClient && activeNavClient.id && isEmpty(clientSystems)) {
            initializeFetch();
        }
    }, [activeNavClient]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (systemFilters.type || Object.values(systemFilters.priority).includes(true)) {
                if (!isEmpty(targetNavCompany) && !isEmpty(clientSystemsMeta)) {
                    initializeFetch();
                }
            } else {
                const init = async () => {
                    initializeFetch();
                };
                
                if (activeNavClient.id && !isEmpty(clientSystems)) init();
            }
        }
    }, [systemFilters, dashboardStartTimeStamp, dashboardEndTimeStamp, searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            let page = 1;

            if ( skip && take ) {
                page = skip / take + 1;
            }

            if (sortFilter) {
                await fetchDashboardData(activeNavCompany.id, 'ClientSystem', { clientId: activeNavClient.id, sort: sortFilter, searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            } else {
                await fetchDashboardData(activeNavCompany.id, 'ClientSystem', { clientId: activeNavClient.id, sort: 'default^desc', searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            }

            setRefreshTab();
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const initializeFetch = async () => {
        setSkip(0);

        const typeFilters = systemFilters.type.map(filter => filter.id);
        const priorityFilters = keys(pickBy(systemFilters.priority));

        setTypeFilters(typeFilters);
        setPriorityFilters(priorityFilters);

        setTableProps({
            search: searchTerm,
            sort:   sortFilter
        });

        if (sortFilter) {
            await fetchDashboardData(activeNavCompany.id, 'ClientSystem', { clientId: activeNavClient.id, sort: sortFilter, limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        } else {
            await fetchDashboardData(activeNavCompany.id, 'ClientSystem', { clientId: activeNavClient.id, sort: 'default^desc', limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        }
    };

    const fetchSystemListAfterCreate = async searchTerm => {
        setSkip(0);

        await fetchDashboardData(activeNavCompany.id, 'ClientSystem', { clientId: activeNavClient.id, sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `system?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}&system=${dataItem.systemId}`;
    };

    const renderScoreNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `system?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}&system=${dataItem.systemId}&viewChildId=4b25aeb8-45d4-4522-9f77-870ab40abb07`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/system';

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;
        queryValues.system = dataItem.systemId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        } else {
            resetNavOptions('site');
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        await fetchSingleSite(queryValues);
    };

    const nameCell = props => {
        return (
            <td>
                <Link
                    to={renderNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const scoresCell = props => {
        let value = props.dataItem[props.field];
        value = value.toString().includes('.') ? parseFloat(value).toFixed(2) : value;

        return (
            <td>
                <Link
                    to={renderScoreNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {value + '%'}
                </Link>
            </td>
        );
    };

    const fetchDashboardSystems = async searchTerm => {
        setSkip(0);

        await fetchDashboardData(companyId, 'ClientSystem', { clientId, sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const handleEditSystem = async systemData => {
        setSystemData(systemData);
        setNavSite({ id: systemData.siteId, name: systemData.siteName });

        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=d0f113f5-32e1-4e2c-bf4d-386edb7f9bc4&client=${systemData.clientId}&company=${activeNavCompany.id}&entityId=${systemData.systemId}&entityType=system&parentId=33ba6af0-1e7a-4fcf-b75b-f355a01a962b&site=${systemData.siteId}`,
                state:    { 'returnUrl': `/v2/dashboard/client?appId=${bob.key}&childId=e3b10bc7-eec5-45e5-8ad2-e94c8f50ca95&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=a73c8c70-35aa-48b7-a797-4c607ae25280` }
            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const fetchSystemDataForDelete = (systemData) => {
        setSystemData(systemData);
        handleToggleDeleteSystemModal(true);
    };

    const subscribeSystemData = (systemData) => {
        systemData.name = systemData.systemName;
        systemData.id = systemData.systemId;

        setSystemData(systemData);
        handleToggleSubscribeToSystemsAlertsModal(true);
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    entityData={props.dataItem}
                    onSubscribeAlerts={(entityData) => { subscribeSystemData(entityData); }}
                    onDelete={(entityData) => fetchSystemDataForDelete(entityData)}
                    onFetch={(entityData) => handleEditSystem(entityData)}
                />
            </td>
        );
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const actionFilterCell = props => {
        return (
            <div />
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td className={props.className} style={props.style}>
                <img className={ props.dataItem[props.field] > 0 ? classes.IconImage: classes.IconImageGray} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const defaultColumnList = [
        {
            title:       dashboardContent.system,
            field:       'systemName',
            id:          'systemColumn',
            cell:        nameCell,
            width:       250,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: false
        },
        {
            title:       dashboardContent.systemType,
            field:       'systemTypeName',
            width:       225,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.client,
            field:       'clientName',
            width:       300,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.site,
            field:       'siteName',
            width:       300,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.equipment,
            field:       'equipmentCount',
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.sensors,
            field:       'sensorCount',
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.score,
            field:       'systemScore',
            cell:        scoresCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.faults,
            field:       'totalFaultCount',
            width:       175,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.high,
            field:       'highFaultCount',
            width:       175,
            cell:        priorityCell,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.medium,
            field:       'mediumFaultCount',
            width:       175,
            cell:        priorityCell,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.low,
            field:       'lowFaultCount',
            width:       175,
            cell:        priorityCell,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       '',
            field:       '',
            cell:        actionsCell,
            locked:      true,
            sortable:    false,
            filterable:  false,
            filterCell:  actionFilterCell,
            width:       75,
            show:        true,
            actionCell:  true,
            reorderable: false
        }
    ];
    const [columnList, setColumnList] = useState(defaultColumnList);

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef}
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(clientSystems, dataState)}
                    {...dataState}
                    pageable={pageable}
                    reorderable={true}
                    onDataStateChange={onDataStateChange}
                    filterable={workbookModeEnabled}
                >
                    {
                        bobLoading.includes('ClientSystem') || isEmpty(clientSystemsMeta) ?
                            <GridNoRecords>
                                Loading systems
                            </GridNoRecords>
                            :
                            null
                    }
                    {
                        columnList.map(
                            (column, index) => 
                                column.show && (
                                    <Column
                                        key={index}
                                        field={column.field}
                                        title={column.title}
                                        id={column.id}
                                        cell={column.cell}
                                        width={column.id === 'systemColumn' ? systemColumnWidth : column.width}
                                        filter={column.filter}
                                        filterCell={column.filterCell}
                                        sortable={column.sortable}
                                        filterable={column.filterable}
                                        locked={column.locked}
                                        reorderable={column.reorderable}
                                    />
                                )
                        )
                    }
                </Grid>
                {
                    subscribeToAlertsSystemsModalOpen ?
                        <CreateSubscriptionModal
                            parent={systemData}
                            parentLabel="System"
                            handleToggleSubscribeToAlertsModal={handleToggleSubscribeToSystemsAlertsModal}
                        />
                        :
                        null
                }
                {
                    createEquipmentModalOpen ?
                        <BobModal
                            title={systemData ? 'Edit System' : 'Add New System'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                setSystemData(null);
                                handleToggleCreateEquipmentModal(false);}}
                        >
                            <CreateEquipmentOrSystemModal
                                system={systemData}
                                isEdit={systemData ? true : false}
                                isFromSystemTab={isFromSystemTab}
                                fetchSystemListAfterCreate={(name) => fetchSystemListAfterCreate(name)}
                                onClose={() => {
                                    setSystemData(null);
                                    handleToggleCreateEquipmentModal(false);}}
                            />
                        </BobModal> : ''
                }
                {
                    deleteSystemModalOpen ?
                        <BobModal
                            title={'Delete Entity'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                handleToggleDeleteSystemModal(false);
                                setSystemData(null);}}
                        >
                            <DeleteSystemModal
                                system={systemData}
                                fetchDashboardSystems={fetchDashboardSystems}
                                onClose={() => {
                                    handleToggleDeleteSystemModal(false);
                                    setSystemData(null);}}
                            />
                        </BobModal> : ''
                }
                {
                    bobLoading.includes('ClientSystem') || isEmpty(clientSystemsMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

SystemsTable.defaultProps = {
    clientSystems: []
};

SystemsTable.propTypes = {
    clientSystems: array
};

const mapStateToProps = state => ({
    activeNavClient:             state.bob.activeNavClient,
    activeNavCompany:            state.bob.activeNavCompany,
    bobLoading:                  state.bob.bobLoading,
    clientSystems:               state.dashboard.clientSystems,
    clientSystemsMeta:           state.dashboard.clientSystemsMeta,
    companies:                   state.core.companies,
    dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
    dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    systemFilters:               state.dashboard.systemFilters,
    targetNavCompany:            state.bob.targetNavCompany
});

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SystemsTable));
